import { cn } from "@/lib";
import useUiStore from "@/store/ui.state";
import { useNavigate } from "@vixi/router";
import { ComponentProps, FC, PropsWithChildren } from "react";
import { GoBackBtn } from "./backBtn";

export const headerHeight = "100px";

export interface HeaderRootProps extends ComponentProps<"div"> {
  isVisible?: boolean;
  sidebarWidth: number;
}

export const Header: FC<PropsWithChildren> = () => {
  const navigate = useNavigate();
  const {
    header: { goBack, isVisible, children, rootProps },
  } = useUiStore();

  return (
    <div
      style={{ height: headerHeight }}
      {...rootProps}
      className={cn(
        "bg-background sticky top-0 z-50 w-full",
        isVisible() ? "block" : "hidden",
        rootProps?.className,
      )}
    >
      <div className="flex h-full items-start justify-between ps-7.5 pe-0 lg:ps-12.5">
        {/* Left-aligned button or content */}
        {goBack && (
          <GoBackBtn
            onBack={() => {
              if (typeof goBack === "function") {
                goBack();
              } else if (typeof goBack === "boolean") {
                history.back();
              } else if ("to" in goBack) {
                navigate(goBack);
              }
            }}
          />
        )}

        {children}
      </div>
    </div>
  );
};
